import type { ScreenshotAsset, ThemedScreenshotAsset } from "./landing-data";

export function resolveThemedScreenshot(screenshot: ThemedScreenshotAsset, theme: "light" | "dark"): ScreenshotAsset {
  return {
    src: theme === "dark" ? screenshot.dark : screenshot.light,
    alt: screenshot.alt,
    caption: screenshot.caption,
  };
}

export function ScreenshotCard({
  screenshot,
  title,
  caption,
  showOverlay = true,
  className = "",
}: {
  screenshot: ScreenshotAsset;
  title: string;
  caption?: string;
  showOverlay?: boolean;
  className?: string;
}) {
  return (
    <div className={`relative overflow-hidden rounded-2xl bg-slate-950/80 shadow-2xl ${className}`}>
      <img
        src={screenshot.src}
        alt={screenshot.alt}
        loading="lazy"
        width={1920}
        height={1080}
        className="h-full w-full object-contain"
      />
      {showOverlay && (
        <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-linear-to-t from-black/70 via-black/35 to-transparent p-4">
          <p className="text-sm font-semibold text-white">{title}</p>
          {caption && <p className="mt-1 max-w-2xl text-xs text-white/85">{caption}</p>}
        </div>
      )}
    </div>
  );
}

export function FeatureScreenshotCard({ title, caption, screenshot }: { title: string; caption: string; screenshot: ScreenshotAsset }) {
  return (
    <div className="relative overflow-hidden rounded-3xl border border-border-subtle bg-bg-secondary/70 aspect-[5/4] min-h-[280px]">
      <img src={screenshot.src} alt={screenshot.alt} loading="lazy" width={1920} height={1080} className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-linear-to-t from-black/65 via-black/20 to-transparent" />
      <div className="absolute bottom-5 left-5 right-5">
        <h3 className="text-xl font-semibold tracking-tight text-white">{title}</h3>
        <p className="mt-1 max-w-sm text-sm text-white/85">{caption}</p>
      </div>
    </div>
  );
}
